import React from 'react'
import { useEffect } from "react";

export function EmbedForm() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "46792350",
          formId: "72750545-d8c8-480e-9cfd-522566d3b85a",
          target: "#hubspotForm" // important: point to a container div
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <div id="hubspotForm"></div> {/* form will render here */}
    </div>
  );
}


export function EmbedVideo () {
  return (
    <>
      <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
        {/* <iframe
          title='Vimeo Player'
          src='https://player.vimeo.com/video/670326833?h=e767650b9b&color=40BBF5&title=0&byline=0&portrait=0'
          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
          allow='autoplay; fullscreen; picture-in-picture'
          allowFullScreen
        /> */}
      </div>
    </>
  )
}

// export function EmbedForm () {
//   return (
//     <iframe
//       className='ns-embedded-form'
//       src='https://7072555.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=7072555&formid=3&h=AAFdikaILG4y4fZiQ4J0Cit7PveTmSrc7jlWZ9cBG9p7ic9xQIE'
//       width='100%'
//     />
//   )
// }
